import DateInput from '@/common/components/base/input/dateInput/DateInput';
import ModalInput from '@/common/components/base/input/modalInput/ModalInput';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import Typography from '@/common/components/base/typography/Typography';
import { INSURANCE_NUMBER_RULE } from '@/common/utils/rules/insurance.rules';
import { requiredText } from '@/common/utils/rules/publicRules';
import {
  validateNotFutureDate,
  validateNotPastDate,
} from '@/modules/adjusterReportModules/IncidentDetails/utils/incidentDetails.util';
import useEditBodyInsurance from '@/modules/adjusterReportModules/Insurer-information/components/bodyInsurance/editBodyInsurance/hook/useEditBodyInsurance';
import { css } from 'styled-system/css';
import { Flex } from 'styled-system/jsx';

const BodyForm = () => {
  const { insurances, isPending, setName } = useEditBodyInsurance();
  return (
    <Flex direction="column" gap="1" pt={24}>
      <Flex direction="column" gap="1" pt={24}>
        <Typography color={'purple-1'} mb={'1rem'} textStyle={'b1'}>
          اطلاعات بیمه بدنه
        </Typography>
        <ModalInput
          name="insurance_body_info.insurance"
          placeholder="انتخاب کنید"
          label="بیمه‌گر"
          title="بیمه‌گر"
          disabled
          loading={isPending}
          searchOptions={{
            onChange: (e) => {
              setName(e);
            },
          }}
          options={insurances?.map((insurance) => ({
            label: insurance?.name as string,
            value: insurance?.id as number,
          }))}
        />
        <TextInput
          placeholder="شماره بیمه نامه را وارد کنید"
          label="شماره بیمه نامه"
          name="insurance_body_info.insurance_number"
          rules={{
            required: { message: requiredText, value: true },
            ...INSURANCE_NUMBER_RULE,
          }}
          max={25}
        />
        <Flex direction="row">
          <DateInput
            label="تاریخ شروع"
            buttonText="ثبت"
            modalLabel="تاریخ شروع"
            name="insurance_body_info.insurance_start_date"
            rules={{
              required: { message: requiredText, value: true },
              validate: validateNotFutureDate,
            }}
            className={css({
              borderLeftRadius: '0px',
            })}
            isDefaultValueEmpty={true}
          />
          <DateInput
            label="تاریخ انقضا"
            buttonText="ثبت"
            modalLabel="تاریخ انقضا"
            rules={{
              required: { message: requiredText, value: true },
              validate: validateNotPastDate,
            }}
            name="insurance_body_info.insurance_expiry_date"
            className={css({
              borderRightRadius: '0px',
            })}
            isDefaultValueEmpty={true}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default BodyForm;
